import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { PageHeader } from "antd";
import { AuthCheck, AUTH_ACTIONS } from "authorization";
import { DISPLAY_MODE } from "Constants";
import {
  createComponentStore,
  useStoreActions,
  useStoreState,
} from "easy-peasy";
import FourOThree from "Pages/private/403";
import React, { useEffect, useState } from "react";
import {
  Redirect,
  useHistory,
  useParams,
  useRouteMatch,
} from "react-router-dom";
import { ContractStoreModel, ACTION_TYPES } from "store/models/contracts/index";
import { fixDates, GenerateBackPath } from "Utils";
import ContractForm from "../components/form";
import FourOFour from "Pages/private/404";

const useContractStore = createComponentStore(ContractStoreModel);

export default function CopyContractPage({ ...props }) {
  const { id } = useParams();
  const history = useHistory();
  const match = useRouteMatch();

  const { abilities } = useStoreState((store) => store.auth);
  const { updateBreadcrumb } = useStoreActions((store) => store.app);
  const [store, actions] = useContractStore();

  const [contract, setContract] = useState({
    type: null,
    files: [],
    extensionRule: null,
    dateOfBeginning: null,
    dateOfFinish: null,
    dateOfSign: null,
    dateOfPlaceDelivery: null,
    rentableAreas: [],
    conditions: [],
    cashFlows: [],
    documents: [],
    description: "",
    notificationType: null,
    notificationDuration: null,
    timeObject: null,
    mailGroup: null,
    partner: null,
  });

  useEffect(() => {
    if (id) actions.fetchSingle({ id: id });
  }, [id]);

  useEffect(() => {
    if (store.record) {
      updateBreadcrumb({
        object: {
          name: store.record.type.description,
          path: match.path,
        },
        index: 2,
      });

      let cloneContract = { ...contract };
      for (const [key, value] of Object.entries(store.record)) {
        if (key in cloneContract) {
          cloneContract[key] = store.record[key];
        }
      }

      cloneContract.conditions.forEach((condition) => {
        delete condition.id;
      });

      cloneContract.rentableAreas.forEach((rentableArea) => {
        delete rentableArea.id;
      });

      setContract(fixDates(cloneContract));
    }
  }, [store.record]);

  return store.process === ACTION_TYPES.FINISHED && !store.record ? (
    <FourOFour />
  ) : (
    <>
      <PageHeader
        className="customized"
        backIcon={<FontAwesomeIcon icon={["fas", "chevron-left"]} />}
        onBack={() => {
          history.push(GenerateBackPath(match.path, 4));
        }}
        title={`Kopyala ${store.record?.type.description || ""}`}
      />
      {AuthCheck(abilities, AUTH_ACTIONS.NEW_RECORD, "Sözleşmeler") ? (
        <ContractForm
          mode={DISPLAY_MODE.COPY}
          contract={contract}
          loading={store.process === ACTION_TYPES.FETCHING_DATA}
          onAfterSuccess={(response) => {
            history.push(
              `${GenerateBackPath(match.path, 4)}/${response?.id}/detay`
            );
          }}
        />
      ) : (
        <FourOThree />
      )}
    </>
  );
}
